export const RADAR_DIMENSION_ORDER = [
  'RIASEC_IMAGES_elevation',
  'RIASEC_IMAGES_r_score',
  'RIASEC_IMAGES_i_score',
  'RIASEC_IMAGES_a_score',
  'RIASEC_IMAGES_s_score',
  'RIASEC_IMAGES_e_score',
  'RIASEC_IMAGES_c_score',
  'HEROS_JOURNEY_score_coopcomp',
  'HEROS_JOURNEY_score_orderchaos',
  'BIG_FIVE_o_score',
  'BIG_FIVE_c_score',
  'BIG_FIVE_e_score',
  'BIG_FIVE_a_score',
  'BIG_FIVE_n_score',
  'DELEGATION_score_risk',
  'DELEGATION_score_responsibility',
  'EMOTIONS_GAME_score',
  'DIGIT_SPAN_score',
  'NBACK_score',
  'NUMERACY_score',
  'ANALOGICAL_REASONING_score',
  'PROBLEM_SOLVING_score'
]

const fallbackDimension = (key) => ({
  key,
  property: { de: key, en: key }
})

export const sortRadarChartData = (chartData) => {
  const dimensions = chartData?.dimensions ?? []
  const spaces = chartData?.spaces ?? []
  const careers = chartData?.careers ?? []

  const orderIndex = new Map(RADAR_DIMENSION_ORDER.map((k, i) => [k, i]))
  const existingByKey = new Map(dimensions.map((d) => [d.key, d]))

  const orderedExisting = RADAR_DIMENSION_ORDER.filter((k) =>
    existingByKey.has(k)
  ).map((k) => existingByKey.get(k))

  const unorderedExisting = dimensions.filter((d) => !orderIndex.has(d.key))

  const missingDimensions = RADAR_DIMENSION_ORDER.filter(
    (k) => !existingByKey.has(k)
  ).map((k) => fallbackDimension(k))

  const sortedDimensions = [...orderedExisting, ...unorderedExisting]

  const targetKeys = sortedDimensions.map((d) => d.key)

  const sortedSpaces = spaces.map((space) => {
    const byKey = new Map((space.data ?? []).map((x) => [x.dimension_key, x]))
    return {
      ...space,
      data: targetKeys.map(
        (k) => byKey.get(k) ?? { dimension_key: k, result: 0 }
      )
    }
  })

  const sortedCareers = careers.map((career) => {
    const byKey = new Map((career.data ?? []).map((x) => [x.dimension_key, x]))
    return {
      ...career,
      data: targetKeys.map(
        (k) =>
          byKey.get(k) ?? {
            dimension_key: k,
            min: 0,
            max: 0,
            optimal: 0
          }
      )
    }
  })

  return {
    ...chartData,
    dimensions: sortedDimensions,
    spaces: sortedSpaces,
    careers: sortedCareers
  }
}
